module.exports = __webpack_public_path__ + "static/Hawaii3Sm-0cccb664efb775015ecebe4a7af5df1d.jpg";